import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import {
  BsArrowLeftCircleFill,
  BsArrowRightCircleFill,
  BsFillVolumeMuteFill,
  BsFillVolumeUpFill,
  BsPauseFill,
} from "react-icons/bs";
import "./LoginHomeCarousel.css";

const LoginHomeCarousel = ({ content }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isMuted, setIsMuted] = useState(true);
  const [isPaused, setIsPaused] = useState(false);
  const slider = useRef();
  const videoRefs = useRef([]);

  // Force slider height recalculation on slide change
  useEffect(() => {
    const resizeSlider = () => {
      if (slider.current) {
        slider.current.slickGoTo(currentSlide); // Re-render current slide
        window.dispatchEvent(new Event("resize")); // Trigger resize
      }
    };
    resizeSlider();
  }, [currentSlide]);

  const toggleMute = () => {
    setIsMuted(!isMuted);
    videoRefs.current.forEach((video) => {
      if (video) video.muted = !isMuted;
    });
  };

  const togglePlayPause = (index) => {
    const video = videoRefs.current[index];
    if (video) {
      if (video.paused) {
        video.play();
        setIsPaused(false);
      } else {
        video.pause();
        setIsPaused(true);
      }
    }
  };

  const CustomNextArrow = ({ onClick }) => (
    <div className="custom-arrow next" onClick={onClick}>
      <BsArrowRightCircleFill size={"1.25em"} />
    </div>
  );

  const CustomPrevArrow = ({ onClick }) => (
    <div className="custom-arrow prev" onClick={onClick}>
      <BsArrowLeftCircleFill size={"1.25em"} />
    </div>
  );

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true, // Enable arrows to make them visible
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    fade: true,
    adaptiveHeight: true,
    beforeChange: (current, next) => {
      setCurrentSlide(next);
    },
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
        },
      },
    ],
  };

  return (
    <div className="login-new-carousel-container">
      <Slider ref={slider} {...settings}>
        {content.map((slide, index) => (
          <div key={index} className="slide">
            <div className="flex-container">
              <div className="text-content">
                <h1 className="title">{slide.heading1}</h1>
                <p className="subtitle">{slide.heading5}</p>
                <div className="buttons">
                  {slide.buttons &&
                    slide.buttons.map((btn, ind) => (
                      <Link to={"/" + btn.url} key={ind}>
                        <button style={{ zIndex: 9999 }} className="btn">
                          {btn.btn}
                        </button>
                      </Link>
                    ))}
                </div>
                {/* Custom dots placed inside text-content */}
                {/* Custom dots placed inside text-content */}
                <div className="custom-dots-wrapper">
                  <div className="custom-dots-container">
                    {content.map((_, i) => (
                      <div
                        key={i}
                        className={`custom-dot ${
                          currentSlide === i ? "active" : ""
                        }`}
                        onClick={() => slider.current.slickGoTo(i)}
                      />
                    ))}
                  </div>
                </div>
              </div>
              <div className="video-container">
                <video
                  ref={(el) => (videoRefs.current[index] = el)}
                  autoPlay
                  muted={isMuted}
                  loop
                  onClick={() => togglePlayPause(index)}
                >
                  <source
                    src="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4"
                    type="video/mp4"
                  />
                </video>
                {isPaused && (
                  <div className="pause-overlay">
                    <BsPauseFill className="pause-icon" />
                  </div>
                )}
                <div
                  id="muteUnmuteBtn"
                  style={{
                    position: "absolute",
                    bottom: "10px",
                    right: "10px",
                    cursor: "pointer",
                    background: "#fff",
                    borderRadius: "50%",
                    boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                    padding: "8px",
                    display: "flex",
                    zIndex: 1,
                    color: "var(--primary-color)",
                  }}
                  role="button"
                  aria-label="Mute Unmute Button"
                  tabIndex={0}
                  onClick={toggleMute}
                >
                  {isMuted ? <BsFillVolumeMuteFill /> : <BsFillVolumeUpFill />}
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default LoginHomeCarousel;
